import { AxiosRequestConfig } from 'axios';

import { $httpRootApi } from '@core/http-client';

export const agreementsQueries = {
  latest: async (_payload: undefined, config?: AxiosRequestConfig) =>
    await $httpRootApi.get<ArrayBuffer>('/agreements/latest', {
      ...config,
      responseType: 'arraybuffer',
    }),
};
